<div class="event-table-row-container">
  <div class="event-image">
    <app-event-image [thumbnail]="event.thumbnail" />
  </div>

  <div class="event-name" [matTooltip]="event.title">
    <div class="col-name">Evento:</div>
    <div class="col-value">{{ event.title }}</div>
  </div>

  <div class="event-sold-tickets">
    <div class="col-name">Ingressos vendidos:</div>
    <div class="col-value">
      @if (event.sold_quantity != null) {
        {{ event.sold_quantity }}
      } @else {
        &nbsp;
      }
    </div>
  </div>

  <div class="event-revenue">
    <div class="col-name">Faturamento:</div>
    <div class="col-value">
      @if (event.role !== "marketing" && event.total_revenue != null) {
        {{ event.total_revenue | currency: "BRL" }}
      } @else {
        &nbsp;
      }
    </div>
  </div>

  <div class="event-actions">
    <a
      mat-icon-button
      aria-label="Detalhar evento"
      matTooltip="Detalhes do evento"
      [routerLink]="['/producer-area/event', event.id]"
      [queryParams]="event.role === 'marketing' ? { tab: '7' } : null">
      <mat-icon>visibility_outlined</mat-icon>
    </a>
    @if (event.role !== "marketing" && event.role !== "observer") {
      <a
        mat-icon-button
        aria-label="Editar evento"
        matTooltip="Editar evento"
        [routerLink]="['/edit-event', event.id]">
        <mat-icon>edit_outlined</mat-icon>
      </a>
    } @else {
      <span class="event-actions__placeholder" aria-hidden="true"></span>
    }
  </div>
</div>
